export { Stack } from './Stack.js';
//# sourceMappingURL=index.js.map
